<template>
  <div>
    <!-- Modal para seleccionar dirección -->
    <b-modal
      v-model="showAddressSelector"
      title="Seleccionar dirección de envío"
      size="md"
      hide-footer
      hide-header
    >
      <div class="d-flex justify-content-end align-items-center mb-2">
        <b-button
          variant="outline-primary"
          size="sm"
          class="mt-1"
          @click="openAddressSidebar"
        >
          <span>Agregar dirección</span>
        </b-button>
      </div>

      <b-list-group>
        <b-list-group-item
          v-for="address in addresses"
          :key="address.id"
          :class="{ 'bg-secondary text-white': selectedAddressId === address.id }"
          @click="selectAddress(address)"
        >
          <div class="d-flex justify-content-between align-items-start">
            <div>
              <b>
                {{ address.name }}
                <b-badge
                  v-if="address.is_default"
                  variant="warning"
                  pill
                  class="ml-1"
                >
                  Predeterminada
                </b-badge>
              </b>
              <p>
                {{ address.address }}, {{ address.municipality }}, {{ address.department }}
              </p>
              <small v-if="address.reference">Referencia: {{ address.reference }}</small>
            </div>
          </div>
        </b-list-group-item>
      </b-list-group>
    </b-modal>

    <!-- Modal para agregar/editar dirección -->
    <customers-address-form
      v-if="customerId && customerData"
      :show.sync="showAddressSidebar"
      :customer-id="customerId"
      :customer-data="customerData"
      :address-data="null"
      @refresh-data="getCustomerAddresses"
    />
  </div>
</template>

<script>
import axios from '@axios'
import CustomersAddressForm from './CustomersAddressForm.vue'

export default {
  name: 'CustomersAddressSelector',

  components: {
    CustomersAddressForm,
  },

  props: {
    show: {
      type: Boolean,
      required: true,
    },
    customerId: {
      type: [Number, String],
      required: true,
    },
    selectedAddressId: {
      type: [Number, String],
      default: null,
    },
  },

  data() {
    return {
      showAddressSidebar: false,
      addresses: [],
      customerData: {
        id: null,
        name: '',
        addresses: [],
      },
    }
  },

  computed: {
    showAddressSelector: {
      get() {
        return this.show
      },
      set(value) {
        this.$emit('update:show', value)
      },
    },
  },

  watch: {
    show(newVal) {
      if (newVal) {
        this.getCustomerAddresses()
      }
    },
  },

  methods: {
    getCustomerAddresses() {
      axios
        .get(`customer/${this.customerId}`)
        .then(response => {
          this.customerData = {
            ...response.data.data,
            addresses: response.data.data.addresses || [],
          }
          this.addresses = this.customerData.addresses
          // Si se acaba de agregar una dirección, seleccionar la última
          if (this.addresses.length > 0 && !this.showAddressSelector) {
            const newAddress = this.addresses[this.addresses.length - 1]
            this.selectAddress(newAddress)
          }
        })
        .catch(error => {
          this.showErrors(error)
        })
    },

    openAddressSidebar() {
      this.showAddressSidebar = true
      // Cierre del modal de selección de dirección
      this.showAddressSelector = false
    },

    selectAddress(address) {
      this.$emit('address-selected', address)
      this.showAddressSelector = false
    },

    showErrors(error) {
      if (error.response) {
        this.$bvToast.toast(error.response.data.message, {
          title: 'Error',
          variant: 'danger',
          solid: true,
        })
      } else {
        this.$bvToast.toast('Ha ocurrido un error inesperado.', {
          title: 'Error',
          variant: 'danger',
          solid: true,
        })
      }
    },
  },
}
</script>
